import { render, staticRenderFns } from "./CheckoutSuccess.vue?vue&type=template&id=20b34441&scoped=true"
var script = {}
import style0 from "./CheckoutSuccess.vue?vue&type=style&index=0&id=20b34441&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b34441",
  null
  
)

export default component.exports